import { useCallback, useEffect, useState } from "react";
import PortalPaymentsService from "../../../services/portalPayment";

export const useFetchSavedMethods = (
  provider: any,
  setSelectedOption: React.Dispatch<React.SetStateAction<string>>,
) => {
  const [saved, setSaved] = useState<any[]>([]);

  const [providerData, setProviderData] = useState<any>(null);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = useCallback(
    async (id: string, method: number) => {
      setIsLoading(true);
      try {
        const providerInfo: any = await PortalPaymentsService.fetchProvider(id);

        setProviderData(providerInfo);

        const response: any = await PortalPaymentsService.fetchSaved({
          providerId: id,
          paymentMethodType: method,
        });

        setSaved(response);

        if (response.length > 0) {
          setSelectedOption(response[0].id);
        }

        setIsLoading(false);
      } catch {
        setIsLoading(false);
      }
    },
    [setSelectedOption],
  );

  useEffect(() => {
    if (provider) {
      fetchData(provider.providerId, provider.methodType);
    }
  }, [fetchData, provider]);

  return { saved, providerData, isLoading, setSaved };
};
